import { Request, Response } from 'kts-scaffold-framework/server';
import { CallType } from 'kts-scaffold-framework/utils/ajax';
import { Urls, UserType } from 'kts-platform-frame/entry/constant';
import { MyStore, reducers } from 'kts-platform-frame/redux';
import ApiBasic from 'kts-platform-frame/api/ApiBasic';
import IOptions from './IOptions';
import { Base64 } from 'js-base64';

/**
 * UserInfo
 * 获取用户数据
 */
class UserInfo extends ApiBasic<IOptions, void> {

    /** 入口 */
    public async api(option: IOptions): Promise<Response<void>> {

        const { user } = MyStore.instance.getState();
        const data: Response<any> = await this.callAjax(new Request(CallType.GET, Urls.COMPANY_USER_INFO, option));
        if (data.er) {
            return data;
        }

        data.res.cUserId = data.res.userId;
        delete data.res.userId;
        user.currentcompanyId = data.res.companyId;
        user.userInfo = data.res;
        
        await MyStore.instance.dispatch(reducers.user.ActionTypes.fnSetUserInfo, user);
 
        return new Response<void>(null);
    }
}

export default new UserInfo().run;



// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/api/company/userInfo/index.ts